<div class="container-fluid mt-3">
  <p-toast></p-toast>

  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="mb-0">Drip Campaign Instances</h4>
  </div>

  <!-- Filters -->
  <div class="card mb-3">
    <div class="card-body py-2">
      <div class="row align-items-end">
        <div class="col-md-3">
          <label class="small mb-1">Status</label>
          <p-multiSelect [options]="statusOptions" [(ngModel)]="selectedStatuses"
                         optionLabel="label" optionValue="value"
                         placeholder="Select statuses" [style]="{'width':'100%'}"></p-multiSelect>
        </div>
        <div class="col-md-3">
          <label class="small mb-1">Task Source</label>
          <p-multiSelect [options]="taskSourceOptions" [(ngModel)]="selectedTaskSources"
                         optionLabel="label" optionValue="value"
                         placeholder="All sources" [style]="{'width':'100%'}"></p-multiSelect>
        </div>
        <div class="col-md-3">
          <label class="small mb-1">Search (by Source ID)</label>
          <input pInputText [(ngModel)]="searchText" placeholder="Source ID..."
                 class="form-control" (keyup.enter)="applyFilters()" />
        </div>
        <div class="col-md-2">
          <button pButton type="button" label="Search" icon="pi pi-search"
                  class="p-button-primary w-100" (click)="applyFilters()"></button>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <p-table [value]="instances"
           [lazy]="true"
           (onLazyLoad)="loadLazy($event)"
           [paginator]="true"
           [rows]="50"
           [totalRecords]="recordTotal"
           [loading]="loading"
           [sortMode]="'multiple'"
           [multiSortMeta]="multiSortMeta"
           dataKey="dripCampaignInstanceId"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
           responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="dripCampaignInstanceId" style="width:80px">ID <p-sortIcon field="dripCampaignInstanceId"></p-sortIcon></th>
        <th style="min-width:150px">Template ID</th>
        <th style="width:120px">Source</th>
        <th style="width:100px">Status</th>
        <th style="width:100px">Progress</th>
        <th style="width:120px">Next Step</th>
        <th pSortableColumn="createDate" style="width:120px">Created <p-sortIcon field="createDate"></p-sortIcon></th>
        <th style="width:130px">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-inst>
      <tr>
        <td>{{inst.dripCampaignInstanceId}}</td>
        <td>Template #{{inst.dripCampaignTemplateId}}</td>
        <td>
          <ng-container *ngIf="getEntityRoute(inst); else noLink">
            <a [routerLink]="getEntityRoute(inst)" class="text-primary">
              {{getTaskSourceLabel(inst.taskSource)}} #{{inst.taskSourceId}}
            </a>
          </ng-container>
          <ng-template #noLink>
            {{getTaskSourceLabel(inst.taskSource)}} #{{inst.taskSourceId}}
          </ng-template>
        </td>
        <td>
          <span class="badge"
                [ngClass]="{
                  'badge-success': inst.status === 'ACTIVE',
                  'badge-warning': inst.status === 'PAUSED',
                  'badge-info': inst.status === 'COMPLETED',
                  'badge-secondary': inst.status === 'COLD',
                  'badge-danger': inst.status === 'CANCELLED'
                }">{{inst.status}}</span>
        </td>
        <td>
          Step {{inst.currentStepOrder ?? '?'}}
        </td>
        <td>
          <span [ngClass]="{'text-danger': inst.nextStepDate && getNextStepRelative(inst.nextStepDate).startsWith('overdue')}">
            {{inst.nextStepDate ? getNextStepRelative(inst.nextStepDate) : '—'}}
          </span>
        </td>
        <td>{{inst.createDate | date:'MM/dd/yy HH:mm'}}</td>
        <td>
          <button pButton type="button" icon="pi pi-eye" class="p-button-sm p-button-text"
                  title="View detail" (click)="onViewDetail(inst)"></button>
          <button *ngIf="inst.status === 'ACTIVE'" pButton type="button" icon="pi pi-pause"
                  class="p-button-sm p-button-text p-button-warning"
                  title="Pause" (click)="onPause(inst)"></button>
          <button *ngIf="inst.status === 'PAUSED'" pButton type="button" icon="pi pi-play"
                  class="p-button-sm p-button-text p-button-success"
                  title="Resume" (click)="onResume(inst)"></button>
          <button *ngIf="inst.status === 'ACTIVE' || inst.status === 'PAUSED'"
                  pButton type="button" icon="pi pi-ban"
                  class="p-button-sm p-button-text p-button-danger"
                  title="Cancel" (click)="onCancelPrompt(inst)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="8" class="text-center p-4">No instances found.</td></tr>
    </ng-template>
  </p-table>
</div>

<!-- Cancel reason dialog -->
<p-dialog header="Cancel Campaign" [(visible)]="showCancelDialog" [modal]="true"
          [style]="{width:'400px'}" [closable]="true">
  <div class="form-group">
    <label>Reason (optional)</label>
    <textarea pInputTextarea [(ngModel)]="cancelReason" class="form-control" rows="3"
              placeholder="Reason for cancellation"></textarea>
  </div>
  <p-footer>
    <button pButton type="button" label="Cancel" class="p-button-secondary mr-2"
            (click)="showCancelDialog = false"></button>
    <button pButton type="button" label="Confirm Cancel" class="p-button-danger"
            (click)="confirmCancel()"></button>
  </p-footer>
</p-dialog>

<!-- Instance detail drawer (shown inline) -->
<app-drip-campaign-instance-detail
  *ngIf="showDetail && selectedInstance"
  [instance]="selectedInstance"
  (closed)="onDetailClosed()">
</app-drip-campaign-instance-detail>
